import * as angular from 'angular';
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {AddressesService} from "../../../addresses/services/addresses-service.factory";
import {AttachmentsService} from "../../../attachments/services/attachments-service.service";
import {OrdersService} from "../../../orders/services/orders-service.service";
import {DeliveriesAlertsService} from "../../services/deliveries-alerts.service";
import {DeliveriesService} from "../../services/deliveries-service.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {PackageConfigurationService} from "../../../site-preferences/services/package-configuration-service.service";
import {FieldCategoryType} from "../../../site-preferences/types/field-category.type";
import {FieldType} from "../../../site-preferences/types/field.type";
import {TaskPurposeType} from "../../../commons/types/task-purpose.type";
import {ServicesViewsStateType} from "../../types/services-views-state.type";
import {ViewSettingsHolderType, ViewSettingsModel, ViewSettingsType} from "../../../commons/models/view-settings.model";
import {ViewSettingsService} from "../../../commons/services/view-settings-service.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class DeliveriesGroupSelectorCtrl implements IController {
  account: AccountModel;
  delivery: any;
  customers: any;
  pricePlanBundle: any;
  pricePlan: any;
  isSubmitting?: boolean;
  onSubmit: Function;
  onCancel: Function;

  public siteInfo: any;
  public isShouldSendSms: boolean;
  public rePrice: boolean;
  private taskColorByPurpose: any;
  private selectedRelatedType: any;
  private identificationOptions: any;
  private quotes: any;
  private quoteCopy: any;
  private addressZoneId: any;
  private vehicleTypes: any;
  private pricePlanType: any;
  private showReschedule: any;
  private showDetails: any;
  private showPackages: any;
  private enableDateEdit: any;
  private accountPurose: any;
  private attachmentsUrls: any;
  private deliveryRef: any;
  private deliveryCopy: any;
  private customAddressEnabled: any;
  private addMarker: any
  private selectedDate: any;
  private availableDays: any;
  private packageSizes: any
  private defaultItemSize: any
  private selectedQuote: any;
  public canCreateTag: boolean;
  public proxyProviderType: any;
  public cashOnDeliveryActionTypesMap: any;
  public subTaskOptionsMap: any;
  public newRelatedTasksMap: any = {};
  public enablePackageEdit: boolean = false;
  public canUpdateExternalId: boolean;
  public viewFormSettings: ViewSettingsModel;
  public useLegacyServiceTime: boolean;

  /* @ngInject */
  constructor(private $log, private $delivery, private deliveriesAlertsService: DeliveriesAlertsService, private commonsAlertsService: CommonsAlertsService,
              private deliveriesService: DeliveriesService, private addressesService: AddressesService,
              private $timeout: ITimeoutService, private siteContextService: SiteContextService, private viewSettingsService: ViewSettingsService,
              private ordersService: OrdersService, private tasksConstants, private packageConfigurationService: PackageConfigurationService,
              private moment, private attachmentsService: AttachmentsService, private IAMPermissions, private splitService: SplitService) {
    this.taskColorByPurpose = this.tasksConstants.typesToColor;
    this.selectedRelatedType = this.tasksConstants.relationTypes[0];
    this.siteInfo = this.siteContextService.getSiteInfo();
    this.canUpdateExternalId = this.IAMPermissions.hasPermission('services.update.externalId');
  }

  $onInit() {
    this.cashOnDeliveryActionTypesMap = {
      Collect: true,
      Payment: true
    };

    this.proxyProviderType = this.siteInfo.proxyProviderType;
    this.identificationOptions = {
      Pickup: [],
      Dropoff: []
    };

    this.useLegacyServiceTime = !this.delivery.taskList[0].taskSpec.detailedServiceTime;

    this.canCreateTag = this.IAMPermissions.hasPermission('infoTags.create');

    this.quotes = [];
    this.vehicleTypes = [];
    this.attachmentsUrls = [];
    // ctrl.pricePlanType = ctrl.pricePlanBundle.entryList[0].type;
    this.pricePlanType = this.pricePlan || this.delivery.pricePlanType;
    this.showReschedule = false;
    this.showDetails = true;
    this.showPackages = true;
    this.enableDateEdit = false;
    this.isShouldSendSms = true;

    this.accountPurose = 'Pickup';
    this.deliveryRef = this.$delivery(this.delivery.id);
    this.deliveryCopy = angular.copy(this.delivery);
    // this.customAddressEnabled = {
    //   Pickup: this._isCustomAddressEnabled(ctrl.delivery, 'Pickup'),
    //   Dropoff: this._isCustomAddressEnabled(ctrl.delivery, 'Dropoff')
    // };
    this.customAddressEnabled = {
      Pickup: false,
      Dropoff: false
    };
    this.addMarker = {
      enabledIndex: undefined,
      purpose: undefined
    };

    this._loadOrderSettings(this.pricePlanType, true);
    this._loadQuotes();

    const blobNames = _.map(_.get(this.delivery, 'attachments'), 'name');

    if (blobNames.length) {
      this.attachmentsService.getAttachmentsUrls(blobNames)
        .then((attachmentsUrls) => {
          this.attachmentsUrls = attachmentsUrls;
          _.forEach(this.attachmentsUrls, (attachment) => {
            attachment.mimeType = this.attachmentsService.getAttachmentsMimeType(attachment.name);
          })
        });
    }

    this._initViewSettings();
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onReferenceIdsChange(referenceIds) {
    this.deliveryCopy.referenceIds = referenceIds;
  }

  onPackageChange(packageItem, index) {
    _.set(packageItem, 'size', packageItem.type);
    _.unset(packageItem, 'type');

    const itemsCopy = angular.copy(this.deliveryCopy.packageList[0].items);

    itemsCopy[index] = packageItem;
    this.deliveryCopy.packageList[0].items = itemsCopy;
  }

  submit(event, form) {
    form.Pickup.$setSubmitted();
    form.Dropoff.$setSubmitted();

    if (form.$valid) {
      if (!this.deliveryCopy.notBefore || !this.deliveryCopy.notAfter) {
        this.deliveriesAlertsService.noTimeWindowInfo();
        return;
      }
      this.onSubmit({delivery: this.deliveryCopy, isShouldSendSms: this.isShouldSendSms, rePrice: this.rePrice});
    } else {
      this.commonsAlertsService.formInvalidInfo();
    }
  }

  cancel() {
    this.onCancel();
  }

  onIdentificationsChange(identifications, taskRef) {
    taskRef.taskSpec.identifications = identifications
  }

  onPackageListItemsChange(items) {
    this.$log.debug('onPackageListItemsChange', items);
    this.deliveryCopy.packageList[0].items = items;
  }

  onAddAttachment() {
    this.deliveriesService.addDeliveryAttachments()
      .then((attachment) => {
        if (!this.deliveryCopy.attachments) {
          this.deliveryCopy.attachments = [];
        }
        this.deliveryCopy.attachments.push(attachment);
      });
  }

  onRemoveAttachment(index) {
    this.deliveryCopy.attachments.splice(index, 1);
  }

  onTagsChange(tagNames) {
    this.deliveryCopy.tagNames = tagNames;
  }

  swapTasks() {
    this.ordersService.swapTasks(this.deliveryCopy);
    // New Changes
    const tmpCustomerPickup = this.customers.Pickup;
    this.customers.Pickup = this.customers.Dropoff;
    this.customers.Dropoff = tmpCustomerPickup;

    const tmpCustomAddressEnabledPickup = this.customAddressEnabled.Pickup;
    this.customAddressEnabled.Pickup = this.customAddressEnabled.Dropoff;
    this.customAddressEnabled.Dropoff = tmpCustomAddressEnabledPickup;

    this.accountPurose = this.accountPurose === 'Pickup' ? 'Dropoff' : 'Pickup';
    this.addMarker.enabledIndex = this.addMarker.enabledIndex ? (this.addMarker.enabledIndex === 0 ? 1 : 0) : undefined;
    this.addMarker = {
      enabledIndex: this.addMarker.enabledIndex ? (this.addMarker.enabledIndex === 0 ? 1 : 0) : undefined,
      purpose: this.addMarker.purpose === 'Pickup' ? 'Dropoff' : 'Pickup'
    }
  }

  onQuoteChange(quote) {
    if (!this.quoteCopy) {
      this.quoteCopy = quote;
    }
    this._assignQuote(quote);
  }

  onLocationButtonToggle(isAddressButtonEnabled, task, index) {
    isAddressButtonEnabled = !isAddressButtonEnabled;
    this.addMarker = {
      enabledIndex: isAddressButtonEnabled ? index : undefined,
      purpose: isAddressButtonEnabled ? task.taskSpec.purpose : undefined
    };
  }

  toggleDetails() {
    this.showDetails = !this.showDetails;
  }

  toggleReschedule() {
    this.showReschedule = !this.showReschedule;
  }

  togglePackages() {
    this.showPackages = !this.showPackages;
  }

  onEditDate() {
    this.enableDateEdit = true;
  }

  onRedoDate() {
    this.enableDateEdit = false;
    this.quoteCopy = null;
    this._updateDeliveryQuote(this.delivery);
  }

  onEditPackage() {
    this.enablePackageEdit = true;
  }

  onRedoPackage() {
    this.enablePackageEdit = false;
    this.deliveryCopy.packageList[0].items = this.delivery.packageList[0].items;
  }


  onToggleCustom(task, index) {
    const taskPurposeRef = task.taskSpec.purpose;
    this.customAddressEnabled[taskPurposeRef] = !this.customAddressEnabled[taskPurposeRef];

    const taskPurposeToDisableCustom = taskPurposeRef === 'Pickup' ? 'Dropoff' : 'Pickup';
    this.customAddressEnabled[taskPurposeToDisableCustom] = false;

    this.addMarker = {
      enabledIndex: this.customAddressEnabled[taskPurposeRef] ? index : undefined,
      purpose: this.customAddressEnabled[taskPurposeRef] ? taskPurposeRef : undefined
    };
  }

  onTaskLocationSelect(location) {
    const index = this.addMarker.enabledIndex;
    this._setLatLng(location.lat, location.lng, index);
  }

  onCustomerChange(customer, purpose) {
    this.customers[purpose] = customer;
    this.addMarker = {
      enabledIndex: undefined,
      purpose: undefined
    };
  }

  onAddressChange(address, taskRef, $index) {
    const taskIndex = $index || _.findIndex(this.deliveryCopy.taskList, (t: any) => {
      return t.id === taskRef.id;
    })

    this.deliveryCopy.taskList[taskIndex].taskSpec.address = address;
    if (!_.isEmpty(address)) {
      const from = this.moment(this.selectedDate).startOf('day').valueOf();
      const to = this.moment(this.selectedDate).endOf('day').valueOf();

      this._loadQuotes(from, to);
    }
  }

  setQuotesByDate(date) {
    const from = this.moment(date).startOf('day').valueOf();
    const to = this.moment(date).endOf('day').valueOf();

    this._loadQuotes(from, to);
  }

  onRelationTypeChange(relationType) {
    this.selectedRelatedType = relationType;
  }

  onAddRelatedTask(relatedTask, task) {
    if (relatedTask) {
      if (!task.relations) {
        task.relations = [];
      }
      task.relations.push(
        {
          type: this.selectedRelatedType,
          relatedTaskId: relatedTask.id,
          details: {
            serviceType: relatedTask.serviceType,
            taskPurpose: relatedTask.taskSpec.purpose,
            serviceId: relatedTask.serviceId,
            serviceExternalId: relatedTask.serviceExternalId,
            accountId: relatedTask.account.id,
            accountName: relatedTask.account.name,
            agentId: _.get(relatedTask, 'agent.id'),
            agentFirstName: _.get(relatedTask, 'agent.user.firstName'),
            agentLastName: _.get(relatedTask, 'agent.user.lastName'),
            status: relatedTask.status
          }

        }
      );
      task.relations = _.uniqBy(task.relations, 'relatedTaskId');

      this.newRelatedTasksMap[relatedTask.id] = true;
    }
  }

  onRemoveRelatedTask(task, $index) {
    task.relations.splice($index, 1);
  }

  onAddSubTaskToTask(task, subtask) {
    if (subtask.actions?.length) {
      subtask.actions = this._getSubTaskActionsWithDefaults(subtask);
    }

    if (task) {
      if (!task.subTasks) {
        task.subTasks = [];
      }
      task.subTasks.unshift(angular.copy(subtask));
    }
  }

  onRemoveSubtask(task, subtask, index) {
    if (task) {
      task.subTasks.splice(index, 1);
      if (!task.subTasks?.length) {
        task.subTasks = undefined;
      }
    }
  }

  onSubTasksChanged(task, subTasks) {
    if (task) {
      task.subTasks = subTasks;
    }
  }

  // ******************************
  //        Internal methods
  // ******************************

  private _getSubTaskActionsWithDefaults(subTask) {
    if (!subTask.actions?.length) return [];

    return subTask.actions.map((a) => {

      if (this.cashOnDeliveryActionTypesMap[a.type]) {

        a.paymentMethods = a.paymentMethods?.length ? a.paymentMethods : [{
          method: undefined,
          requestAmount: undefined,
          editable: true
        }];
      }
      return a;
    });
  }

  private _isCustomAddressEnabled(delivery, purpose) {
    return _.findIndex(delivery.taskList, (t: any) => {
      return t.taskSpec.purpose === purpose && !t.taskSpec.address.placeId;
    }) !== -1;
  }

  private _updateDeliveryQuote(deliveryRef) {
    this.deliveryCopy.notBefore = deliveryRef.notBefore;
    this.deliveryCopy.notAfter = deliveryRef.notAfter;

    _.forEach(this.deliveryCopy.taskList, (t) => {
      t.taskSpec.notBefore = deliveryRef.notBefore;
      t.taskSpec.notAfter = deliveryRef.notAfter;
    });

    this.deliveryCopy.urgency = deliveryRef.urgency;
  }

  private _loadQuotes(from?, to?) {

    if (this.deliveryCopy.taskList[1]?.taskSpec?.address &&
      !!Object.keys(this.deliveryCopy.taskList[1]?.taskSpec?.address).length) {

      var services = this._getServices(this.deliveryCopy);

      this.ordersService.getOrderQuote(services, this.delivery.accountId, this.pricePlanType, from, to)
        .then((service) => {
          this.quotes = service.quotes;
          this.addressZoneId = _.get(service, 'destinationZoneId');

          const todayQuote = _.find(service.quotes, (q) => {
            return this.moment(q.startTime).isSame(this.moment(), 'day');
          });
          this._assignQuote(todayQuote || _.get(this.quotes, '[0]'), true);
        })
    }
  }

  private _loadOrderSettings(selectedPricePlanType, isInit) {

    this.ordersService.getOrderSettings(this.delivery.accountId, this.delivery.serviceType, selectedPricePlanType)
      .then((orderSettings) => {


        this.availableDays = _.get(orderSettings, 'availableDays', []);
        this.packageSizes = orderSettings.itemSizeList;
        this.defaultItemSize = orderSettings.defaultItemSize;
        this.subTaskOptionsMap = {
          [TaskPurposeType.Pickup]: [],
          [TaskPurposeType.Dropoff]: []
        }

        orderSettings.optionalSubTasks.forEach(optionalSubTask => {
          if (optionalSubTask.purposes.includes(TaskPurposeType.Pickup)) {
            this.subTaskOptionsMap.Pickup.push(optionalSubTask);
          }

          if (optionalSubTask.purposes.includes(TaskPurposeType.Dropoff)) {
            this.subTaskOptionsMap.Dropoff.push(optionalSubTask);
          }
        })
        this.vehicleTypes = _.get(orderSettings, 'vehicleList', []);

        if (!isInit) {
          this.deliveryCopy.vehicleType = _.get(orderSettings, 'defaultVehicle');
        }
        this.identificationOptions = {
          Pickup: this.ordersService.buildIdentificationOptions(
            orderSettings.pickupPodSettings,
            orderSettings.pickupPodFillRequiredSettings
          ),
          Dropoff: this.ordersService.buildIdentificationOptions(
            orderSettings.dropoffPodSettings,
            orderSettings.dropoffPodFillRequiredSettings
          ),
        };
      })
  }

  private _assignQuote(quote?, isInit?) {
    this.selectedQuote = angular.copy(quote);

    if (_.get(quote, 'type') === 'PerTask') {
      quote = this.quotes[0];
    }

    this.selectedDate = quote ? new Date(_.get(quote, 'startTime')) : undefined;

    if (!isInit) {
      this.deliveriesService.updateDeliveryQuote(this.deliveryCopy, quote);
    }
  }

  private _setLatLng(lat, lng, taskIndex) {
    this.$timeout(0).then(() => {
      this.deliveryCopy.taskList[taskIndex].taskSpec.address.location = this.addressesService.getAddressLocation(lat, lng);
    });
  }

  private _getServices(delivery) {
    const services = [{
      serviceType: delivery.serviceType,
      tasks: []
    }];
    delivery.taskList.forEach((task: TaskModel) => {
      services[0].tasks.push({
        purpose: task.taskSpec.purpose,
        address: task.taskSpec.address,
        depotId: _.get(task, 'taskSpec.depotReference.id'),
        serviceTimeInMillis: _.get(task, 'taskSpec.serviceTime')
      });
    });
    return services;
  }

  private _initViewSettings() {
    this.viewSettingsService.getBySite(ServicesViewsStateType.DELIVERIES_FORM_STATE, ViewSettingsType.Form)
      .then((viewSettings: ViewSettingsModel[]) => {
        const userViewFormSettings = viewSettings.find(v => v.holderType === ViewSettingsHolderType.Site);
        if (userViewFormSettings) {
          this.viewFormSettings = userViewFormSettings
        } else {
          this.viewFormSettings = viewSettings.find(v => v.holderType === ViewSettingsHolderType.Site);
        }
      })
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveryEditView', {
    bindings: {
      account: '<',
      delivery: '<',
      customers: '<',
      pricePlanBundle: '<',
      pricePlan: '<',
      viewType: '<',
      isSubmitting: '<?',
      onSubmit: '&',
      onCancel: '&'
    },
    template: require('./delivery-edit-view.html').default,
    controller: DeliveriesGroupSelectorCtrl
  });
